<section class="dealer-header">
    <div class="dealer-header-logo">
        <a class="logo-display" (click)="routeTo()">
            <img id="logo" alt="{{ currentDealershipName }} logo" />
        </a>

        <app-dealer *ngIf="selectedDealer" [dealerSelection]="selectedDealer" [user]="user" (outEvent)="eventHandler($event)"></app-dealer>
    </div>

    <div *ngIf="menu$ | async as menu">
        <ng-container *ngIf="!showUserName; else avatar">
            <span [matMenuTriggerFor]="belowMenu" class="material-icons menu">menu</span>
        </ng-container>
        <ng-template #avatar>
            <div class="avatar" [matMenuTriggerFor]="belowMenu">
                <div class="circle">
                    {{ this.user?.firstName?.substr(0, 1).toLocaleUpperCase() }}
                    {{ this.user?.lastName?.substr(0, 1).toLocaleUpperCase() }}
                </div>
                <span>{{ user.firstName }} {{ user.lastName }}</span>
                <mat-icon>arrow_drop_down</mat-icon>
            </div>
        </ng-template>
        <mat-menu #belowMenu="matMenu" yPosition="below">
            <button *ngFor="let menuItem of menu" mat-menu-item class="header-item" (click)="navigate(menuItem)">
                <mat-icon [class.disabled]="menuItem.disabled">{{ menuItem.icon }}</mat-icon>
                <mat-label [class.disabled]="menuItem.disabled">{{ menuItem.title }}</mat-label>
            </button>
        </mat-menu>
    </div>
</section>
